<template>
  <header class="has-text-centered pt-2">
    <img :src="`/img/header-secure-${locale}.png`" class="is-inline-block"/>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {
    locale: { type: String, default: 'en' }
  },
}
</script>

<style lang="scss" scoped>
header {
  background-color: #114F81;
}

.enneagram {
  header {
    background-color: #36895F;
  }
}
</style>